import { AuthContent, AuthContext } from '@admin/components/auth'
import EmailField from '@admin/components/form/emailfield'
import Button from '@admin/components/button'
import Image from '@admin/components/image'
import T from '@admin/components/t'
import PropTypes from 'prop-types'
import React from 'react'

class Email extends React.Component {

  static contextType = AuthContext

  static propTypes = {
    context: PropTypes.shape({
      admin: PropTypes.object,
      flash: PropTypes.object,
      host: PropTypes.object,
      network: PropTypes.object,
      provider: PropTypes.object,
      router: PropTypes.object
    }),
    onNext: PropTypes.func,
    onRedirect: PropTypes.func
  }

  emailRef = null

  state = {
    email: '',
    message: null,
    status: 'pending'
  }

  _handleActivation = this._handleActivation.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)
  
  constructor(props) {
    super(props)
    this.emailRef = React.createRef()
  }

  render() {
    const { provider } = this.props.context
    const { message } = this.state
    return (
      <AuthContent>
        <div className="maha-auth-form">
          <div className="maha-auth-header">
            <div className="maha-logo">
              <div className="maha-logo-badge">
                <div className="maha-logo-wrapper">
                  <Image { ...this._getLogo() } />
                </div>
              </div>
            </div>
            <h2><T text={ provider.title } /></h2>
            <p><T text="t(Sign in To Your Account)" /></p>
            { message &&
              <div className="maha-auth-error">
                <T text={ message } />
                { message === 'Your account has not been activated' &&
                  <><br /><Button { ...this._getActivation() } /></>
                }
              </div>
            }
          </div>
          <div className="ui form">
            <div className="field email-field">
              <EmailField { ...this._getEmail() } />
            </div>
            <div className="field">
              <Button { ...this._getContinue() } />
            </div>
          </div>
        </div>
      </AuthContent>
    )
  }

  componentDidMount() {
    setTimeout(() => {
      if(!this.emailRef.current) return
      this.emailRef.current.focus()
    }, 600)
  }

  _getActivation() {
    return {
      label: 't(resend activation email)',
      className: 'link',
      handler: this._handleActivation
    }
  }

  _getContinue() {
    const { status } = this.state
    return {
      label: 't(Continue)',
      loading: status === 'submitting',
      color: 'blue',
      size: 'large',
      handler: this._handleSubmit
    }
  }

  _getEmail() {
    return {
      ref: this.emailRef,
      onEnter: this._handleSubmit,
      placeholder: 't(Enter Email)',
      onChange: this._handleUpdate.bind(this, 'email')
    }
  }

  _getLogo() {
    const { provider } = this.props.context
    return {
      src: provider.logo,
      title: provider.title,
      host: provider.asset_host,
      transforms: { fit: 'cover', w: 150, h: 150 }
    }
  }

  _handleActivation() {
    const { email } = this.state
    this.props.context.network.request({
      endpoint: '/api/admin/signin/activation',
      method: 'POST',
      body: { email },
      onSuccess: () => {
        this.setState({
          message: 't(Please check your email for activation instructions)'
        })
      },
      onFailure: ({ message }) => {
        this.setState({ message })
      }
    })
  }

  _handleSubmit() {
    const { email } = this.state
    this.setState({ 
      message: null,
      status: 'submitting' 
    })
    this.props.context.network.request({
      endpoint: '/api/admin/signin/email',
      method: 'POST',
      body: { email },
      onSuccess: ({ data }) => {
        const account = data
        if(account.authentication_strategy !== 'local') return this.props.onRedirect(account)
        if(account.is_locked_out) return this.props.onNext('lockout')
        if(account.is_blocked) return this.props.onNext('blocked')
        this.props.onNext('password', { account })

      },
      onFailure: ({ message }) => {
        this.context.shake()
        this.setState({
          message,
          status: 'pending'
        })
      }
    })
  }

  _handleUpdate(key, value) {
    this.setState({
      [key]: value
    })
  }

}

export default Email
